import * as React from "react";
import type { SVGProps } from "react";

interface BankProps extends SVGProps<SVGSVGElement> {
  isActive?: boolean;
}

const ACTIVE_COLOR = "#002A73";
const INACTIVE_COLOR = "#CECECE";

const Bank = ({ isActive = false, stroke, width, height, ...props }: BankProps) => {
  const currentStroke = isActive ? ACTIVE_COLOR : stroke || INACTIVE_COLOR;

  // Highlight using the roof path (like in other icons)
  const highlightD = "M2.625 10.5H25.375L14 3.5L2.625 10.5Z";

  return (
    <svg
      {...props}
      width={width ?? "28"}
      height={height ?? "28"}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {isActive && <path opacity="0.2" d={highlightD} fill={ACTIVE_COLOR} />}
      <path
        d="M2.625 10.5H25.375L14 3.5L2.625 10.5Z"
        stroke={currentStroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.125 10.5V19.25"
        stroke={currentStroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.375 10.5V19.25"
        stroke={currentStroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.625 10.5V19.25"
        stroke={currentStroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.875 10.5V19.25"
        stroke={currentStroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 19.25H24.5"
        stroke={currentStroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.75 22.75H26.25"
        stroke={currentStroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default Bank;
